import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../config/config";

export function AddButcher() {
  const [animalTypes, setAnimalTypes] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    butcherName: "",
    cnic: "",
    contact: "",
    address: "",
    advance: "",
    ageed_amt: "",
    cat_id: "",
    sub_cat_id: "",
  });

  const [errors, setErrors] = useState({});

  // 1. Initial Fetch: Animal Types
  useEffect(() => {
    const fetchAnimalTypes = async () => {
      try {
        const response = await fetch(`${config.baseUrl}/api/subcategories/filteranimal-type`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        const data = await response.json();
        setAnimalTypes(data);
      } catch (e) { console.error("Error fetching animal types:", e); }
    };
    fetchAnimalTypes();
  }, []);

  // 2. Dynamic Fetch: Sub-Categories based on Animal Type selection
  const fetchSubCategories = async (catId) => {
    const selectedYear = localStorage.getItem('qurbani_year') || new Date().getFullYear();
    if (!catId) {
      setSubCategories([]);
      return;
    }
    try {
      const res = await fetch(`${config.baseUrl}/api/subcategories/filtersubcat/${catId}?year=${selectedYear}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const data = await res.json();
      setSubCategories(data);
    } catch (err) { console.error("Error fetching subcategories:", err); }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    // Agar Animal Category change ho toh Sub-Category fetch karo
    if (name === "cat_id") {
      setFormData((prev) => ({ ...prev, sub_cat_id: "" })); // Reset sub-cat
      fetchSubCategories(value);
    }

    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.butcherName) newErrors.butcherName = "Butcher name is required";
    if (!formData.cnic || formData.cnic.length !== 13) newErrors.cnic = "13-digit CNIC required";
    if (!formData.contact) newErrors.contact = "Contact is required";
    if (!formData.advance) newErrors.advance = "Advnace amount is required";
    if (!formData.ageed_amt) newErrors.ageed_amt = "Amount is required";
    if (!formData.cat_id) newErrors.cat_id = "Category is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsLoading(true);
    try {
      const response = await fetch(`${config.baseUrl}/api/butcher/addButcher`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          ...formData,
          cat_id: parseInt(formData.cat_id, 10),
          sub_cat_id: parseInt(formData.sub_cat_id, 10) || null
        })
      });
      if (response.ok) navigate("/butcher/view");
      else alert("Failed to add butcher");
    } catch (e) { alert("Server Error"); }
    finally { setIsLoading(false); }
  };

  // --- LOGIN THEME CLASSES (LIGHT MODE - #F1F5F9) ---
  const inputCls = "block w-full px-4 py-4 border border-slate-200 rounded-2xl bg-slate-50 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-500 sm:text-sm transition-all duration-200";
  const labelCls = "block text-xs font-bold text-slate-600 uppercase mb-2 ml-1";

  return (
    <main className=" flex flex-col items-center">
      <div className="w-full max-w-4xl">
        <div className=" md:p-10 rounded-3xl shadow-xl border border-slate-200">
          <div className=" border-b border-slate-100 pb-2 text-center md:text-left">
            <h3 className="text-xl font-extrabold text-slate-800 uppercase tracking-tight">Butcher Details</h3>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">

              {/* Left Column */}
              <div className="space-y-5">
                <div>
                  <label className={labelCls}>Full Name</label>
                  <input name="butcherName" value={formData.butcherName} onChange={handleInputChange} className={inputCls} placeholder="Enter full name" />
                  {errors.butcherName && <p className="mt-1.5 text-[11px] text-red-500 font-bold ml-2">{errors.butcherName}</p>}
                </div>

                <div>
                  <label className={labelCls}>CNIC Number (13 Digits)</label>
                  <input name="cnic" value={formData.cnic} onChange={handleInputChange} className={inputCls} placeholder="35201XXXXXXXX" maxLength="13" />
                  {errors.cnic && <p className="mt-1.5 text-[11px] text-red-500 font-bold ml-1">{errors.cnic}</p>}
                </div>

                <div>
                  <label className={labelCls}>Contact Number</label>
                  <input name="contact" value={formData.contact} onChange={handleInputChange} className={inputCls} placeholder="03XXXXXXXXX" />
                  {errors.contact && <p className="mt-1.5 text-[11px] text-red-500 font-bold ml-2">{errors.contact}</p>}
                </div>
              </div>

              {/* Right Column */}
              <div className="space-y-5">
                <div className="flex flex-col md:flex-row gap-4">
                  {/* First Input Group */}
                  <div className="flex-1">
                    <label className={labelCls}>Advance (PKR)</label>
                    <input
                      type="number"
                      name="advance"
                      value={formData.advance}
                      onChange={handleInputChange}
                      className={inputCls}
                      placeholder="5000"
                    />
                    {errors.advance && <p className="mt-1.5 text-[11px] text-red-500 font-bold ml-2">{errors.advance}</p>}
                  </div>

                  {/* Second Input Group (Example: Payment Method or Balance) */}
                  <div className="flex-1">
                    <label className={labelCls}>Agreed Rate</label>
                    <input
                      type="number"
                      name="ageed_amt"
                      value={formData.ageed_amt}
                      onChange={handleInputChange}
                      className={inputCls}
                      placeholder="5000"
                    />
                    {errors.ageed_amt && <p className="mt-1.5 text-[11px] text-red-500 font-bold ml-2">{errors.advance}</p>}

                  </div>
                </div>


                <div>
                  <label className={labelCls}>Animal Category</label>
                  <select name="cat_id" value={formData.cat_id} onChange={handleInputChange} className={inputCls}>
                    <option value="">Select Category</option>
                    {animalTypes.map(type => <option key={type.id} value={type.id}>{type.cat_name}</option>)}
                  </select>
                  {errors.cat_id && <p className="mt-1.5 text-[11px] text-red-500 font-bold ml-2">{errors.cat_id}</p>}
                </div>

                <div>
                  <label className={labelCls}>Sub Category</label>
                  <select name="sub_cat_id" value={formData.sub_cat_id} onChange={handleInputChange} className={inputCls} disabled={!formData.cat_id}>
                    <option value="">Select Sub-Category</option>
                    {subCategories.map(item => <option key={item.id} value={item.id}>{item.sub_cat || item.name}</option>)}
                  </select>
                </div>
              </div>

              <div className="md:col-span-2">
                <label className={labelCls}>Full Address</label>
                <textarea name="address" value={formData.address} onChange={handleInputChange} className={`${inputCls} h-24 resize-none`} placeholder="Enter Street, Area, City details..."></textarea>
              </div>
            </div>

            <div className="">
              <button
                type="submit"
                disabled={isLoading}
                className="w-full flex justify-center items-center py-4 px-4 border border-transparent text-sm font-black rounded-2xl text-white bg-indigo-800 hover:bg-indigo-700 transition-all active:scale-[0.98] disabled:opacity-70 shadow-lg shadow-blue-200"
              >
                {isLoading ? "PROCESSING DATA..." : "ADD BUTCHER"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>

  );
}